import { pdfjs } from 'react-pdf';

/**
 * PD-14841: serve the pdf.js worker from our own bundle instead of the unpkg
 * CDN it previously pointed at.
 *
 * The worker is the background thread that parses the PDF, so PDF rendering
 * cannot start until it loads. Fetching it from a third-party host meant every
 * viewer depended on that host being reachable — a tenant network policy that
 * blocks unpkg, or an unpkg outage, broke document preview with no signal on
 * our side. It also placed third-party-served code in the execution path.
 *
 * That cost used to be paid only when a user deliberately opened a document.
 * Now that the match-review panel renders PDFs inline on selection, it would
 * be paid while simply flipping through candidates, so it has to come from us.
 *
 * `pdfjs-dist` is already a direct dependency (react-pdf's own peer), so this
 * adds no new package — the worker file ships inside it, and the bundler
 * emits it as a local asset.
 */
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
	'pdfjs-dist/build/pdf.worker.min.mjs',
	import.meta.url,
).toString();
